import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	archivedPlansAriaLabel: {
		id: 'inactive-plans-directory-base.filters.archived-plans-aria-label',
		defaultMessage: 'Search archived plans',
		description: 'It is an aria label for archived plans searchfield.',
	},
	trashedPlansAriaLabel: {
		id: 'inactive-plans-directory-base.filters.trashed-plans-aria-label',
		defaultMessage: 'Search trashed plans',
		description: 'It is an aria label for trashed plans searchfield.',
	},
});
